import React, { useEffect, useState } from 'react';

import { AppContext } from '../provider/AppContextProvider';

declare global {
  interface Window {
    traffective: any;
    gptadslots: any;
  }
}

export default function StickyAd() {
  const { adsReady } = React.useContext(AppContext);

  const showAd = (process.env.NEXT_PUBLIC_SHOW_ADS === "true" && process.env.NEXT_PUBLIC_SHOW_STICKY_ADS == "true") ? true : false
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if(process.env.NEXT_PUBLIC_SHOW_ADS === "true" && adsReady && showAd && window.traffective && window.traffective.refreshBottomSticky) {
      window.traffective.refreshBottomSticky("Mobile_Sticky")
      

      if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
        document?.querySelector(".ad-sticky")?.classList.add('pb-3');
      } else {
      }

    }
  }, [adsReady, showAd])

  const removeAd = () => {
    setVisible(false);
  }

  return (
    <React.Fragment>
      {showAd && visible &&
        <div className="sticky-ad-row sticky-ad-row-hidden">
          <div className="ad-sticky-flap" id="ad-sticky-flap">
            <p>Anzeige</p>
            <div id="ad-sticky-flap-close" className="close__ad-tag" onClick={() => removeAd()}>
              <div className="close__line__1"></div>
              <div className="close__line__2"></div>
            </div>
          </div>
          <div id="traffective-ad-Mobile_Sticky" className="Mobile_Sticky"></div>
        </div>
      }
    </React.Fragment>
  );
}